<template>
  <div
    class="action"
    :class="{
      current: current_action_id && current_action_id === action.id,
      wide: className && className === 'wide',
    }"
    @click="viewAction(action)"
  >
    <div
      class="checkmark"
      :class="{ completed: action.completed, overdue: overdue(action) }"
      @click.stop.prevent="toggleCompleted(action)"
      v-tooltip="{ content: getToggleTooltip(action), delay }"
    ></div>

    <div class="action-card">
      <div class="left">
        <div class="type-icon" :class="action.priority">
          <div
            class="img"
            :class="
              !action || !action.type
                ? ''
                : action.type.replace(/ /g, '').toLowerCase()
            "
          ></div>
          <div class="flag">
            <svg
              viewBox="0 0 10 10"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <path
                  d="M8,7.64099947 C8.41244847,7.54102233 8.9255632,7.48657365 9.61697217,7.48657365 C10.9894466,7.48657365 11.5413461,8.14229529 13.2028186,8.14229529 C14.0057244,8.14229529 14.940445,8.02844754 15.7925684,7.59218917 C16.2848957,7.34013424 16.9999945,7.49179215 16.9999945,8.06044728 C16.9999945,8.39307572 16.9999945,10.021523 16.9999945,12.9457891 C16.9999968,13.7648687 16.447006,14.4806709 15.6544634,14.6874741 C14.808023,14.9083411 13.990808,15.0121405 13.2028186,14.9988721 C11.4055843,14.9686099 10.9373777,14.3072822 9.61697217,14.2474182 C9.10528139,14.2242194 8.54831214,14.2679453 8,14.3777725 L8,16.5302897 C8,16.7897035 7.77614237,17 7.5,17 C7.22385763,17 7,16.7897035 7,16.5302897 L7,7.46971034 C7,7.21029648 7.22385763,7 7.5,7 C7.77614237,7 8,7.21029648 8,7.46971034 L8,7.64099947 Z"
                  id="path-1"
                ></path>
              </defs>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-7.000000, -7.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use
                    fill="#979797"
                    fill-rule="nonzero"
                    xlink:href="#path-1"
                  ></use>
                </g>
              </g>
            </svg>
          </div>
        </div>

        <h4
          class="title"
          :class="{ placeholder: !action.title }"
          v-tooltip="{ content: action.title, delay }"
        >
          {{ action.title || 'Task title' }}
        </h4>
      </div>

      <div class="right">
        <div class="project-details" v-if="action.project">
          <span
            class="title"
            v-tooltip="{ content: action.project.name, delay }"
            >{{ action.project.name }}</span
          >
          <span class="status" :class="action.project.status.toLowerCase()">{{
            action.project.status
          }}</span>
        </div>

        <img
          class="attachment"
          :class="{ visible: action.linkedDocs && action.linkedDocs.length }"
          src="~@/assets/icons/attachment.png"
        />
        <div
          class="date"
          :class="{ overdue: overdue(action) }"
          v-if="action.dueDate"
          v-tooltip="{ content: getDateTooltip(action), delay }"
        >
          {{ formatDate(action.dueDate) }}
        </div>
        <img
          class="attachment date visible"
          src="~@/assets/icons/date.svg"
          v-if="!action.dueDate"
        />
        <div class="assignee" v-if="action.assignee">
          {{ action.assignee.initials }}
        </div>
        <div class="assignee" v-if="!action.assignee">
          <img src="~@/assets/icons/user.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'ActionCard',
  data() {
    return {
      delay: { show: 700, hide: 0 },
      dateFormat: 'DD MMM',
    };
  },
  props: {
    action: Object,
    viewAction: Function,
    className: String,
  },
  computed: {
    current_action_id() {
      return this.$store.getters.current_action_id;
    },
    today() {
      return moment().startOf('d');
    },
    view_mode() {
      return this.$store.getters.action_tray_view_mode;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format(this.dateFormat);
    },
    getDateTooltip(action) {
      if (this.overdue(action)) {
        return 'Overdue by ' + this.overdue_by(action) + ' days';
      }
      return '';
    },
    toggleCompleted(action) {
      Vue.set(action, 'completed', !action.completed);
      this.$store.dispatch('updateAction', {
        action,
        project_id: this.project_id,
        refresh_after: this.view_mode === 'project',
      });
    },
    getToggleTooltip(action) {
      if (action.completed) {
        return 'Mark as incomplete';
      } else {
        return 'Mark as complete';
      }
    },
    overdue(action) {
      if (!action.dueDate) return false;
      const due_day = moment(action.dueDate).startOf('d');
      return due_day.isBefore(this.today) && !action.completed;
    },
    overdue_by(action) {
      if (!this.overdue) {
        return '';
      }

      const due_day = moment(action.dueDate).startOf('d');
      return this.today.diff(due_day, 'd');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.action {
  height: 62px;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  position: relative;
  backface-visibility: hidden;

  &:hover {
    background: white;

    .checkmark {
      opacity: 1;
    }
  }

  &.current,
  &.current:hover {
    background: #e4e7ed;
  }

  .checkmark {
    position: absolute;
    top: 22px;
    left: 36px;
    opacity: 0;
    width: 18px;
    height: 18px;
    background-image: url(~@/assets/icons/completedIcons.svg);
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 18px 72px;

    &:hover {
      opacity: 1;
      background-position: top -18px center;
    }

    &.completed,
    &.completed:hover {
      opacity: 1;
      background-position: top -36px center;
    }

    &.overdue,
    &.overdue:hover {
      opacity: 1;
      background-position: top -54px center;
    }
  }

  .action-card {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-top: 1px solid #e2e5ec;
    margin-left: 85px;
    margin-right: 25px;
    width: calc(100% - 110px);
    height: 100%;
    transition: all 0.5s;

    .project-details {
      display: none;
    }

    > div {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      width: 100%;

      &.right {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        justify-content: flex-end;

        .date {
          width: 44px;
          text-align: right;

          &.overdue {
            color: $red;
            text-decoration: underline;
          }

          &.attachment {
            margin: 0 10px;
            height: 18px;
            opacity: 0;

            &.visible {
              opacity: 1;
            }
          }
        }
      }

      &.left {
        flex: 1;
        max-width: calc(100% - 150px);
      }
    }
  }

  .type-icon {
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 12px;
    position: relative;

    &.High {
      .flag {
        background: $red;
        display: flex;
      }
    }

    &.Medium {
      .flag {
        background: $orange;
        display: flex;
      }
    }

    &.Low {
      .flag {
        background: $yellow;
        display: flex;
      }
    }

    .flag {
      display: none;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      background: #626d79;
      border: 1px solid white;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -6px;
      top: -6px;

      svg {
        width: 8px;
        height: 8px;
        path,
        rect,
        circle {
          fill: white;
        }
      }
    }
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    color: #26292f;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: 100%;

    &.placeholder {
      opacity: 0.25;
    }
  }

  .overflow {
    font-size: 18px;
    color: #acb6c1;
  }

  .assignee {
    border-radius: 15px;
    width: 30px;
    height: 30px;
    background: #26292f;
    color: white;
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 6px;

    img {
      width: 10px;
    }
  }

  .date {
    color: #acb6c1;
    font-weight: 400;
    font-size: 13px;
    margin: 0 10px;
  }

  .attachment {
    margin: 0 0px 0 6px;
    width: 16px;
    height: 16px;
    opacity: 0;

    &.visible {
      opacity: 1;
    }
  }
}

.wide.action {
  background-color: white;
  border: 1px solid #e2e5ec;
  border-radius: 4px;
  margin-bottom: 15px;

  .action-card {
    border: none;

    .assignee {
      background: #9ca2a9;
    }
  }

  div.right {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
  }

  div.left {
    max-width: calc(100% - 500px);
  }

  .project-details {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 300px;
    margin-right: 50px;

    .title {
      font-size: 13px;
      color: #acb6c1;
      font-weight: 500;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }

    .status {
      width: 85px;
      text-align: center;
      display: inline-block;
      margin-right: 10px;
    }
  }
}
</style>
